import { STATUSES } from "@/features/travel-journey-layout/types";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export interface Step {
  title: string;
  index: number;
}

export function useSteps() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const steps: Step[] = [
    {
      title: t("travel_form.travel_info"),
      index: STATUSES.TRAVEL_INSURANCE,
    },
    {
      title: t("travel_form.travelers_info"),
      index: STATUSES.TRAVEL_INFO,
    },
    {
      title: t("travel_form.quote_list"),
      index: STATUSES.QUOTE_LIST,
    },
    {
      title: t("travel_form.passport_info"),
      index: STATUSES.PASSPORT_INFO,
    },
    {
      title: t("travel_form.summary_payment"),
      index: STATUSES.SUMMARY_AND_PAYMENT,
    },
  ];

  const currentStepIndex = useMemo(() => {
    if (/\/(ar|en)\/?$/.test(pathname)) {
      return STATUSES.TRAVEL_INSURANCE;
    }
    if (pathname.endsWith("/traveler-info")) {
      return STATUSES.TRAVEL_INFO;
    }
    if (pathname.endsWith("/quote-list")) {
      return STATUSES.QUOTE_LIST;
    }
    if (pathname.endsWith("/passport-info")) {
      return STATUSES.PASSPORT_INFO;
    }
    if (pathname.endsWith("/summary-and-payment")) {
      return STATUSES.SUMMARY_AND_PAYMENT;
    }
    return STATUSES.TRAVEL_INSURANCE; // Default to first step (root)
  }, [pathname]);

  function getStepTitle(index: number) {
    return steps.find(step => step.index === index)?.title ?? "";
  }

  return { steps, getStepTitle, currentStepIndex };
}
